import { Directive, ElementRef, HostListener, Input, OnDestroy, AfterViewInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TipoMascara } from '../enums/tipo-mascara.enum';
import { MascaraUtil } from '../utils/mascara.util';

@Directive({
  selector: '[appMascara]',
  standalone: true,
})
export class MascaraDirective implements AfterViewInit, OnDestroy {
  @Input('appMascara') tipoMascara?: TipoMascara | string;
  private subscription?: Subscription;

  constructor(private readonly elementRef: ElementRef<HTMLInputElement>, private readonly ngControl: NgControl) {}

  ngAfterViewInit(): void {
    this.aplicarMascaraNoInput();
    const controle = this.ngControl?.control;
    if (controle) {
      this.subscription = controle.valueChanges.subscribe(() => {
        this.aplicarMascaraNoInput();
      });
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const tipo = this.obterTipoMascara();
    if (!tipo) {
      return;
    }
    const valorBruto = MascaraUtil.somenteDigitos(input.value);
    const valorFormatado = MascaraUtil.aplicarMascara(valorBruto, tipo);
    input.value = valorFormatado;

    const controle = this.ngControl?.control;
    if (controle && controle.value !== valorFormatado) {
      controle.setValue(valorFormatado, { emitEvent: false });
    }
  }

  @HostListener('blur')
  onBlur(): void {
    const tipo = this.obterTipoMascara();
    if (!tipo) {
      return;
    }
    const input = this.elementRef.nativeElement;
    const valorBruto = MascaraUtil.somenteDigitos(input.value);
    const valorFormatado = MascaraUtil.aplicarMascara(valorBruto, tipo);
    input.value = valorFormatado;
    const controle = this.ngControl?.control;
    if (controle && controle.value !== valorFormatado) {
      controle.setValue(valorFormatado, { emitEvent: false });
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private aplicarMascaraNoInput(): void {
    const tipo = this.obterTipoMascara();
    if (!tipo) {
      return;
    }
    const controle = this.ngControl?.control;
    const valorBruto = MascaraUtil.somenteDigitos(controle?.value ?? this.elementRef.nativeElement.value);
    const valorFormatado = MascaraUtil.aplicarMascara(valorBruto, tipo);
    this.elementRef.nativeElement.value = valorFormatado;
    if (controle && controle.value !== valorFormatado) {
      controle.setValue(valorFormatado, { emitEvent: false });
    }
  }

  private obterTipoMascara(): TipoMascara | undefined {
    if (!this.tipoMascara) {
      return undefined;
    }
    const chave = String(this.tipoMascara).toUpperCase();
    return (TipoMascara as Record<string, TipoMascara>)[chave];
  }
}
